<template>
  <div class="map-trackable" ref="marker" :style="trackerStyle">
    <div class="map-trackable-initials">{{initials}}</div>
    <div class="map-trackable-heading" :style="headingStyle">
      <i class="fas fa-caret-right" :style="iconStyle"></i>
    </div>
  </div>
</template>

<style scoped lang="scss">
$map-marker-size: 32px;
$map-marker-border-size: 2px;
$map-marker-heading-size: $map-marker-size + $map-marker-border-size*2 + 16px;

.map-trackable {
  position: relative;
  border-radius: 50%;
  width: $map-marker-size;
  height: $map-marker-size;
  background-color: #1F3052;
  border: 2px solid #ebeef3;
  text-align: center;
  font-size: 17px;
  transform: translateY(calc(#{$map-marker-size} / 2));
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.6);
}
.map-trackable .map-trackable-initials {
  color: #FFFFFF;
  font-weight: 400;
  font-size: 14px;
  margin: calc(50% - 9px) 2px;
}
.map-trackable > i {
  color: #FF0000;
  margin: calc(50% - 8px) 2px;
}
.map-trackable-heading {
  position: absolute;
  top: 50%;
  left: 50%;
  width: $map-marker-heading-size;
  height: $map-marker-heading-size;
}
.map-trackable-heading > i {
  position: absolute;
  top: calc(#{$map-marker-heading-size/2} - 13px);
  right: 0;
  bottom: 0;
  font-size: 26px;
  color: #1F3052;
}
</style>

<script>
import Utils from '@/utils/utils'

export default {
  props: {
    google: {
      type: Object,
      required: true
    },
    map: {
      type: Object,
      required: true
    },
    position: {
      type: Object,
      required: true
    },
    rotation: {
      type: Number,
      default: 0
    },
    colour: {
      type: String,
      default: '#ffffff'
    },
    name: String
  },
  data() {
    return {
      mapMarker: null,
      clickListener: null
    }
  },
  computed: {
    trackerStyle() {
      return {
      }
    },
    iconStyle() {
      return {
      }
    },
    headingStyle() {
      let heading = Math.round(this.rotation || 0) - 90
      return {
        transform: `translate(-50%, -50%) rotate(${heading}deg)`
      }
    },
    initials() {
      return Utils.calculateAvatarInitials(this.name)
    }
  },
  watch: {
    position: function() {
      if(this.mapMarker)
        this.mapMarker.position = { lng: this.position.lng, lat: this.position.lat }
    },
  },
  mounted() {
    var markerOptions = {
      position: { lng: this.position.lng, lat: this.position.lat },
      zIndex: 10000,
      map: this.map
    }

    markerOptions.content = this.$refs.marker
    this.mapMarker = new this.google.maps.marker.AdvancedMarkerElement(markerOptions)

    this.clickListener = this.mapMarker.addListener("click", (evt) => {
      this.$emit('click', evt)
    })
  },
  beforeDestroy() {
    if(this.clickListener)
      this.clickListener.remove()
    if(this.mapMarker)
      this.mapMarker.setMap(null)
  }
}
</script>